/**
 * The external dependencies.
 */
import {Link} from 'react-router-dom';
import styled from 'styled-components';

export default styled(Link)`
	font-size: 16px;
	color: #475773;
	font-weight: 500;
	text-decoration: none;
	padding-top: 17px;
`;


// WEBPACK FOOTER //
// ./src/components/auth-form/link.js